import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Typography } from '@fupa/fupa-uikit';
import SponsorAdSlot from 'app/components/ads/SponsorAdSlot';
const Sponsor = styled.div.withConfig({
  componentId: "sc-1jwqgnx-0"
})(["display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;padding-right:1rem;gap:0.25rem;"]);
const SCTypography = styled(Typography).withConfig({
  componentId: "sc-1jwqgnx-1"
})(["&&&{font-style:italic;}"]);
const SponsorAdSlotWithPresentedByClaim = _ref => {
  let {
    extendSlotId
  } = _ref;
  const [displayClaim, setDisplayClaim] = useState(false);
  useEffect(() => {
    const handler = event => {
      const slot = event.slot;
      if (slot.getSlotElementId() === "ad-Sponsor_1-".concat(extendSlotId) && !event.isEmpty) {
        setDisplayClaim(true);
      }
    };
    window.googletag.cmd.push(() => {
      window.googletag.pubads().addEventListener('slotRenderEnded', handler);
    });
    return () => {
      window.googletag.cmd.push(() => {
        window.googletag.pubads().removeEventListener('slotRenderEnded', handler);
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(Sponsor, {
    "data-sentry-element": "Sponsor",
    "data-sentry-component": "SponsorAdSlotWithPresentedByClaim",
    "data-sentry-source-file": "SponsorAdSlotWithPresentedByClaim.tsx"
  }, displayClaim && /*#__PURE__*/React.createElement(SCTypography, {
    variant: "caption1"
  }, "pr\xE4sentiert von"), /*#__PURE__*/React.createElement(SponsorAdSlot, {
    extendSlotId: extendSlotId,
    "data-sentry-element": "SponsorAdSlot",
    "data-sentry-source-file": "SponsorAdSlotWithPresentedByClaim.tsx"
  }));
};
export default SponsorAdSlotWithPresentedByClaim;